import { defineComponent as _defineComponent } from 'vue'
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../../../adapter-vue";
import { isPC } from "../../../../utils/env";
import Icon from "../../../common/Icon.vue";
import SearchDefaultIcon from "../../../../assets/icon/search-default.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return { __sfc: true,TUITranslateService, isPC, Icon, SearchDefaultIcon }
}

})